// index.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { CacheProvider } from "@emotion/react";
import emotionCache from "./emotionCache";
import TelemetryWrapper  from "./telemetry/TelemetryWrapper";

const container = document.getElementById("root");
const root = createRoot(container);

const AppWithProviders = (
  <CacheProvider value={emotionCache}>
    <BrowserRouter basename="/">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <TelemetryWrapper>
            <App />
          </TelemetryWrapper>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </CacheProvider>
);

root.render(AppWithProviders);
